import { FaHouseDamage, FaProjectDiagram } from 'react-icons/fa'
import { MdOutlineElectricMeter } from 'react-icons/md'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                active: ['/user/projects'],
                url: '/user/projects',
                text: 'Projects',
                permission: 'projects.index',
                icon: <FaProjectDiagram />,
            },
            {
                active: ['/user/transformers'],
                url: '/user/transformers',
                text: 'Transformers',
                permission: 'transformers.index',
                icon: <FaHouseDamage />,
            },
            {
                active: ['/user/transformer-tests'],
                url: '/user/transformer-tests',
                text: 'Test Groups',
                permission: 'transformer_tests.index',
                icon: <MdOutlineElectricMeter />,
            },
        ],
    },
]

export default appRoutes
